<template>
  <div>
    <div class="col">
      <h1>Шаблонизатор чека</h1>
      <div style="margin-bottom: 20px">
        <select v-on:change="createOriginList" v-model="picked">
          <option
            v-for="checkSample in checkSamples"
            v-bind:value="checkSample.value"
            :key="checkSample.value"
          >{{checkSample.value}}</option>
        </select>
      </div>

      <div class="column-container">
        <div class="row">
          <div class="column">
            <h4>Дополнительные поля для чека</h4>
            <hr />
            <input type="checkbox" id="checkbox" v-model="imageOnTopCheck" />Изображение
            <div style="position: relative" v-if="imageOnTopCheck">
              <input
                class="userText"
                v-model="imageOnTop"
                placeholder="Укажите название изображения"
                style="margin-top: 5px; margin-bottom: 5px;"
                v-on:change="resetDocumentCheckStatus()"
              />
              <input
                :disabled="isEmpty(imageOnTop)"
                v-on:click="imageStringPush(), resetDocumentCheckStatus()"
                type="image"
                src="add_button.png"
                style="position: absolute; widht: 18px; height: 18px; margin-left: 2px;top: 20%"
              />
            </div>
            <br />
            <input type="checkbox" v-model="isAdvanceTextLineRequired" />Дополнительный текст
            <div style="position: relative" v-if="isAdvanceTextLineRequired">
              <input
                class="userText"
                v-model="advanceTextLine"
                placeholder="Введите текст"
                :maxlength= 'maxLength'
                style="margin-bottom: 5px; margin-bottom: 5px;"
              />
              <input
                :disabled="isEmpty(advanceTextLine)"
                v-on:click="textStringPush(), resetDocumentCheckStatus()"
                type="image"
                src="add_button.png"
                style="position: absolute; widht: 18px; height: 18px; margin-left: 2px"
              />
            </div>
            <draggable
              class="list-group"
              tag="ul"
              v-model="headerLineOptions"
              v-bind="dragOptions"
              :move="onMove"
              @start="isDragging=true"
              @end="isDragging=false"
            >
              <transition-group type="transition" :name="'flip-list'">
                <li
                  class="list-group-item"
                  v-for="element in headerLineOptions"
                  :key="element.order"
                >
                  <i
                    :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'"
                    @click=" element.fixed=! element.fixed"
                    aria-hidden="true"
                  />
                  {{element.name}}
                </li>
              </transition-group>
            </draggable>
          </div>

          <div class="column">
            <h4 class="panel-title">Предпросмотр</h4>
            <hr />
            <label>[</label>
            <label>{{this.starLine}},</label>
            <br />
            <draggable
              class="list-group"
              element="span"
              v-model="formedHeader"
              v-bind="dragOptions"
              :move="onMove"
              @start="isDragging=true"
              @end="isDragging=false"
            >
              <transition-group type="transition" :name="'flip-list'" >
                <li class="list-group-item" v-for="element in formedHeader" :key="element.order">
                  <i
                    :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'"
                    @click=" element.fixed=! element.fixed"
                    aria-hidden="true"
                  />
                  {{element.name}}
                </li>
              </transition-group>
            </draggable>
            <label>{{this.starLine}}]</label>
          </div>

        </div>
      </div>
    </div>

      <h3>Публикация шаблона</h3>
      <div id="generatade-curl">
        <br />
        <input
          class="userText"
          v-on:change="resetDocumentCheckStatus()"
          v-model="dataBaseName"
          placeholder="Введите имя БД"
        />
        <input
          type="checkbox"
          v-on:change="departmentPut(), resetDocumentCheckStatus()"
          id="department"
          v-model="isDepartmentCheck"
          style="margin-left: 5px"
        />Департамент
        <br />

        <input
          class="userText"
          v-on:change="resetDocumentCheckStatus()"
          v-model="dataBasePass"
          placeholder="Введите пароль БД"
        />
        <br />

        <input
          class="userText"
          v-on:change="resetDocumentCheckStatus()"
          v-model="document"
          placeholder="Введите название документа"
        />
        <br />
        <hr />

        <button
          class="button"
          :disabled="some([dataBaseName, dataBasePass, document, picked ], isEmpty)"
          v-on:click="checkCurrentRev()"
        >Статус документа</button>
        <transition name="fade">
          <img :src="imageRevCheckResource" />
        </transition>
        <br />

        <button
          class="button"
          :disabled="some([dataBaseName, dataBasePass, document, picked, currentRev ], isEmpty) || !isCurrentRevChecked"
          v-on:click="pushHeaderToDB()"
        >Опубликовать</button>
        <transition name="fade">
          <img :src="imageDocUpdateResource" />
        </transition>
        <hr />

        <input type="checkbox" v-model="isLocalCurlRequired" style="margin-left: 5px" />
        Загрузить документ через терминал
        <div v-if="isLocalCurlRequired">
          <h4 style="text-align: center">Загрузка через терминал</h4>
          <div class="container pt-4">
            <h4>CURL для шаблона чека</h4>
            <input
              class="userText"
              v-model="currentRev"
              placeholder="Введите ревизию"
            />
            <br />
            <br />

            <button
              class="button"
              v-on:click="buildCurl()"
              :disabled="some([dataBaseName, dataBasePass, document, picked, currentRev ], isEmpty)"
            >Собрать cURL</button>
              <label class="message" v-if="isMessageShowed.document">
                cURL скопирован в буфер
                обмена
              </label>
            <hr />
          </div>
          <div v-if="imageOnTopCheck" class="container pt-5">
            <h4>CURL для изображения</h4>
            <br />
            <input
              class="userText"
              v-model="localImageLocation"
              placeholder="Введите расположение изображения"
              v-on:change="resetDocumentCheckStatus()"
            />
            <br />

            <button
              class="button"
              v-on:click="buildImageCurl()"
              :disabled="some([dataBaseName, dataBasePass, document, picked, currentRev, localImageLocation ], isEmpty)"
            >Собрать cURL изображения</button>

            <label class="message" v-if="isMessageShowed.image">cURL скопирован в буфер обмена</label>
          </div>
        </div>
        <div class="author">Овсянников В.</div>
        <div class="author">2019</div>
      </div>
  </div>
</template>

<script>
import Axios from "axios";
import draggable from "vuedraggable";
import { checkHeaders } from "./headers.js";
import { some, isEmpty } from "lodash";

export default {
  name: "checkSampleGenerator",
  components: {
    draggable
  },
  data: function() {
    return {
      checkSamples: [
        { value: "CheckHeader32" },
        { value: "CheckHeader56" },
        { value: "PrecheckHeader32" },
        { value: "PrecheckHeader56" },
        { value: "KitchenHeader32" },
        { value: "KitchenHeader56" },
        { value: "GuestTicketHeader32" },
        { value: "GuestTicketHeader56" },
        { value: "PrecheckFooter32" },
        { value: "PrecheckFooter56" },
        { value: "KitchenFooter32" },
        { value: "KitchenFooter56" },
        { value: "GuestTicketFooter32" },
        { value: "GuestTicketFooter56" }
      ],
      picked: "CheckHeader32",

      isAdvanceTextLineRequired: false,
      advanceTextLine: "",
      maxLength: "32",
      imageOnTop: "",
      imageOnTopCheck: false,
      imageRevCheckResource: "",
      imageDocUpdateResource: "",

      starLine: '{ "line": "*************************"}',

      dataBaseName: "",
      department: "",
      dataBasePass: "",
      document: "",
      currentRev: "",
      isEmpty,
      some,

      headerLineOptions: checkHeaders['CheckHeader32'].custom.map((name, index) => {
        return { name, order: index + 1, fixed: false };
      }),

      listOnPush: "",
      formedHeader: checkHeaders['CheckHeader32'].origin.map((name, index) => {
        return { name, order: index + 1, fixed: false };
      }),
      editable: true,
      isDragging: false,
      delayedDragging: false,

      curl: "",
      imageCulr: "",
      localImageLocation: "",
      isDepartmentCheck: "",
      isLocalCurlRequired: false,
      isCurrentRevChecked: false,
      isAnswerGet: null,
      isDocumentUpdated: null,
      isMessageShowed: {
        document: false,
        image: false
      }
    };
  },

  methods: {
    resetDocumentCheckStatus() {
      this.isCurrentRevChecked = false;
      this.imageRevCheckResource = "";
      this.currentRev = "";
    },

    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },

    buildCurl() {
      this.curl = `curl -i -X PUT -u ${this.dataBaseName}${this.department}:${
        this.dataBasePass
      } http://cdbm.quickresto.ru/startup_${this.dataBaseName}/${
        this.document
      }/${this.picked}.json?rev=${
        this.currentRev
      } -d '${`[${this.starLine},${this.formedHeader.reduce(
        (acc, item) => {
          return (acc = acc + item.name);
        },
        ""
      )}${this.starLine}]`}'
                `;
      this.$clipboard(this.curl);
      this.isMessageShowed.document = !this.isMessageShowed.document;
    },

    buildImageCurl() {
      this.imageCulr = `curl -X PUT -u ${this.dataBaseName}${this.department}:${
        this.dataBasePass
      } http://cdbm.quickresto.ru/startup_${this.dataBaseName}/${
        this.document
      }/${this.imageOnTop}?rev=${
        this.currentRev
      } --data-binary @${this.slashChanger(this.localImageLocation)}/${
        this.imageOnTop
      } -H "Content-Type: image/bmp"
                    `;
      this.$clipboard(this.imageCulr);
      this.isMessageShowed.image = !this.isMessageShowed.image;
    },

    async checkCurrentRev() {
      this.listOnPush = `[${this.starLine},
                        ${this.formedHeader.reduce((acc, item) => {
                          return (acc = acc + item.name);
                        }, "")}${this.starLine}]`;
      try {
        let response = await Axios.request({
          url: `/startup_${this.dataBaseName}/${this.document}`,
          method: "get",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-type": "text/html"
          },
          withCredentials: true,
          auth: {
            username: this.dataBaseName + this.department,
            password: this.dataBasePass
          },
          responseType: "json"
        });
        this.currentRev = response.data._rev;
        this.isCurrentRevChecked = response.status === 200;
        this.isAnswerGet = true;
        this.imageRevCheckResource = "cloud_ok.png";
      } catch (error) {
        this.isAnswerGet = false;
        this.imageRevCheckResource = "cloud_not_ok.png";
      }
    },

    async pushHeaderToDB() {
      this.isCurrentRevChecked = false;
      try {
        await Axios.request({
          url: `/startup_${this.dataBaseName}/${this.document}/${this.picked}.json?rev=${this.currentRev}`,
          method: "put",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-type": "application/x-www-form-urlencoded"
          },
          withCredentials: true,
          auth: {
            username: this.dataBaseName + this.department,
            password: this.dataBasePass
          },
          data: this.listOnPush
        });
        this.imageDocUpdateResource = "cloud_ok.png";
        let response = await Axios.request({
          url: `/startup_${this.dataBaseName}/${this.document}`,
          method: "get",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-type": "text/html"
          },
          withCredentials: true,
          auth: {
            username: this.dataBaseName + this.department,
            password: this.dataBasePass
          },
          responseType: "json"
        });
        this.currentRev = response.data._rev;
      } catch (error) {
        this.isAnswerGet = false;
        this.imageDocUpdateResource = "cloud_not_ok.png";
      }
    },

    slashChanger(str) {
      let newStr = "";
      for (let i = 0; i < str.length; i++) {
        newStr = str[i] !== "\\" ? newStr + str[i] : newStr + "/";
      }
      return newStr;
    },

    departmentPut() {
      this.department = this.isDepartmentCheck ? "_" : "";
    },

    createOriginList() {
      this.headerLineOptions = checkHeaders[this.picked].custom.map((name, index) => {
        return { name, order: index + 10, fixed: false };
      })
      this.formedHeader = checkHeaders[this.picked].origin.map((name, index) => {
        return { name, order: index + 10, fixed: false };
      })
      this.maxLength = checkHeaders[this.picked].length
      this.starLine = this.maxLength === '32' ? '{ "line": "********************************"}' : '{ "line": "*******************************************************"}'
    },

    imageStringPush() {
      this.formedHeader.push({
        name: `{"image": "${this.imageOnTop}"},`,
        order: 30,
        fixed: false
      });
    },

    textStringPush() {
      this.formedHeader.push({
        name: `{ "line": "${this.advanceTextLine}", "isBold": true, "isDoubleWidth": true, "isDoubleHeight": true},`,
        order: 40,
        fixed: false
      });
    }
  },

  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    },
    listString() {
      return JSON.stringify(this.headerLineOptions, null, 2);
    },
    list2String() {
      return JSON.stringify(this.formedHeader, null, 2);
    }
  },

  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    }
  }
};
</script>

<style>
h3 {
  margin: 40px 0 0;
}

#generatade-curl {
  font-size: 15px;
  text-align: left;
  margin-left: 40px
}

.userText {
  width: 300px;
}

.author {
  position: relative;
  font-size: 10px;
  text-align: center;
}

.button {
  text-decoration: none;
  outline: none;
  display: inline-block;
  width: auto;
  height: auto;
  line-height: 45px;
  border-radius: 45px;
  margin-right: 10px;
  margin-top: 8px;
  font-family: "Montserrat", sans-serif;
  font-size: 11px;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 3px;
  font-weight: 600;
  color: #524f4e;
  background: white;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
  transition: 0.3s;
}

.button:disabled {
  color: #b8b4b3e0;
}

.button:hover:enabled {
  background: #2ee59d;
  box-shadow: 0 15px 20px rgba(46, 229, 157, 0.4);
  color: white;
  transform: translateY(-7px);
}

.message {
  color: #2ee59d;
  font-size: 20px;
}

.column {
  flex-basis: 40%;
  font-size: 12px;
  text-align: left;
  border: 4px double black;
  margin: 20px;
  padding: 10px
}

.column-container {
  flex: 1;
  justify-content: center;
  margin-left: 50px
}

.container {
 margin: 20px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 0px;
  text-align: left;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
 {
  opacity: 0;
}
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 14px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}

.row {
  justify-content: center
}
</style>
